import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, TrendingUp, Package, DollarSign } from 'lucide-react';
export function ProductSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-256">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-258">
          <div className="inline-flex items-center justify-center p-3 bg-amber-100 rounded-full mb-6" data-id="element-259">
            <Sparkles className="w-6 h-6 text-amber-600" data-id="element-260" />
          </div>

          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-stone-900 mb-6 md:mb-8 leading-tight" data-id="element-261">
            O método por trás das lembrancinhas que{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 whitespace-nowrap" data-id="element-262">
              vendem mais caro
            </span>
          </h2>

          <p className="text-sm md:text-base text-stone-700 leading-relaxed font-light max-w-3xl mx-auto" data-id="element-263">
            O{' '}
            <span className="font-bold text-amber-700" data-id="element-264">Efeito Boutique™</span>{' '}
            reúne 40 ideias escolhidas a dedo e ensina como usar material,
            acabamento e apresentação para aumentar o valor percebido dos seus
            produtos —{' '}
            <span className="underline decoration-amber-300 decoration-2 underline-offset-4" data-id="element-265">
              sem aumentar o custo de produção
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}